import script from "./ImageFullscreenSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageFullscreenSlider.vue?vue&type=script&setup=true&lang=js"

import "./ImageFullscreenSlider.vue?vue&type=style&index=0&id=398ca7f2&scoped=true&lang=css"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-398ca7f2"]])

export default __exports__